/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import { Button, ToolTip, Icon } from '@insticator/insticator-ui'; // iui-material
// utils
import { url } from '../../../../../../utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from './exportbox_styles'



/* ========== ~~~~~~~~~~ EXPORTBOX ~~~~~~~~~~ ========== */
const ExportBox = (props) => {
    const { handleExport, title, tipcontent, subdescription, processing, buttontext, value, image} = props

    const handleExportClick = () => handleExport(value)

    return (
        <div className={`exportbox ${props.classes.exportbox}`}>
            <img className={'exportboximg'} src={`${url.image}/illustrations/${image}`}/>
            <div className={'exportdescription'}>
                <span className={'title'}>
                    {title}
                    <span className={'titletip'}>
                        <ToolTip children={<Icon name={'question-circle'}/>} position={'right'} content={tipcontent} />
                    </span>
                </span>
                <span className={'subdescription'}>
                    {subdescription}
                </span>
            </div>
            <div className={'ctabutton'}>
                <Button 
                    klass={'exportbutton'}
                    processing={processing}
                    disabled={processing}
                    variant={'primary'}
                    text={buttontext}
                    action={handleExportClick}
                    type={'action'}
                />
            </div>
        </div>
    );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ExportBox);
